import { render, staticRenderFns } from "./overview-instances.component.vue?vue&type=template&id=74837a64&scoped=true&"
import script from "./overview-instances.component.vue?vue&type=script&lang=ts&"
export * from "./overview-instances.component.vue?vue&type=script&lang=ts&"
import style0 from "./overview-instances.component.vue?vue&type=style&index=0&id=74837a64&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74837a64",
  null
  
)

export default component.exports